import React from 'react'
import { PUBLIC_URL, REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'
import { Item, Logo, LogoLink, Root } from './CertificateHeader.styles'
import { CertificateHeaderFolioSection } from '../CertificateHeaderFolioSection/CertificateHeaderFolioSection.container'

/**
 * The Certificate Header's container.
 */
const CertificateHeader = () => {
  return (
    <Root>
      <Item width="auto">
        <LogoLink href={`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Home`} target="_top">
          <Logo alt="Chilecompra" src={`${PUBLIC_URL}/assets/images/logo_mercadopublico.svg`} />
        </LogoLink>
      </Item>
      <CertificateHeaderFolioSection />
    </Root>
  )
}

export default CertificateHeader
